<template>
  <div
    class="sdiv pl5 cpointer fs16 lh18 prelative mb5 pl20 pr5 article-row"
    :class="{ 'is-hot': isHot }"
    @click="$emit('click')"
  >
    <span v-if="isHot" class="hot-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="14" height="14" xmlns="http://www.w3.org/2000/svg">
        <path fill="#e74c3c" d="M12 23c-3.9 0-7-3.1-7-7 0-2.5 1.2-4.7 3.1-6.1-.3 1.4.1 2.9 1.1 4 0-3.3 2.7-6 6-6 .4 0 .8.1 1.2.2C14.5 5.2 13.3 3.1 13 1c3.3 1.5 5.7 4.8 5.7 8.6 0 .5 0 1-.1 1.5 1.4-1.1 2.4-2.8 2.4-4.7 2.2 1.8 3.6 4.5 3.6 7.6 0 5.4-4.4 9.8-9.8 9.8-.3 0-.6 0-.8-.1z"/>
      </svg>
    </span>
    <span class="article-title">{{item.title}}</span>
    <span class="article-time">{{openTime}}</span>
  </div>
</template>

<script>
export default {
  name: 'PracticeArticleRow',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isHot() {
      return this.item.is_hot == 1 || this.item.is_hot === true
    },
    openTime() {
      if (!this.item.open_time) return ''
      return String(this.item.open_time).substring(0, 10)
    }
  }
}
</script>

<style scoped>
  .article-row {
    display: flex;
    align-items: center;
  }
  .article-row.is-hot::after {
    display: none;
  }
  .hot-icon {
    position: absolute;
    z-index: 2;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
    width: 14px;
    height: 14px;
    line-height: 0;
  }
  .article-title {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .article-time {
    flex-shrink: 0;
    width: 100px;
    text-align: right;
    font-size: 14px;
    color: #999;
  }
</style>



// WEBPACK FOOTER //
// src/components/practice/ArticleRow.vue